import React from 'react';
import {
  Row, Col, Input, Spin,
} from 'antd';
import PropTypes from 'prop-types';

function FormSearchInput({
  onSearch,
  searchStr,
  searchLoading,
  testId,
  placeholder = 'Search',
}) {
  return (
    <Row align="middle" gutter={15}>
      <Col>
        <Input.Search
          type="search"
          style={{ width: 250 }}
          className="searchbar"
          placeholder={placeholder}
          allowClear
          onChange={onSearch}
          value={searchStr}
          data-testid={testId}
        />
      </Col>
      <Col style={{ height: 20, width: 20 }}>
        {searchLoading && <Spin size="small" />}
      </Col>
    </Row>
  );
}

FormSearchInput.propTypes = {
  onSearch: PropTypes.func.isRequired,
  searchStr: PropTypes.string,
  searchLoading: PropTypes.bool,
  testId: PropTypes.string,
  placeholder: PropTypes.string,
};

FormSearchInput.defaultProps = {
  searchStr: undefined,
  searchLoading: false,
  testId: undefined,
  placeholder: 'Search',
};

export default FormSearchInput;
